<ng-container *transloco="let t">
  <div class="heading-container {{cssClass ? cssClass : ''}}"
    [ngClass]="{'clickable': type === LiveResultHeadingType.EVENT}" (click)="onHeadingClick()">
    <div class="image_holder">
      <div class="circle-container">
        @if (status === LiveItemStatus.IN_PROGRESS) {
        <div class="loader">
          <div class="outer-circle"></div>
          <div class="loader-edge"></div>
          <div class="inner-circle">
          </div>
        </div>
        }
        <div class="image-circle">
          @if (race?.imageIcon !== null) {
          <img src="{{race!.imageIcon!}}" alt="">
          } @else if (event?.imageIcon !== null) {
          <img src="{{event!.imageIcon!}}" alt="">
          } @else {
          <img src="assets/img/bg3.jpg" alt="">
          }
        </div>
      </div>
    </div>
    <div class="info">
      @if (type === LiveResultHeadingType.RACE && event) {
      <p class="info__small">
        <app-language-output [hrLabel]="event.name" [enLabel]="event.nameEng" [itLabel]="event.nameIta"
          [siLabel]="event.nameSlo" [defaultLanguage]="event.defaultLanguage" [languages]="languages" />
      </p>
      }

      <p class="info__name">
        @if (type === LiveResultHeadingType.RACE && race) {
        <app-language-output [hrLabel]="race.name" [enLabel]="race.nameEng" [itLabel]="race.nameIta"
          [siLabel]="race.nameSlo" [defaultLanguage]="event?.defaultLanguage" [languages]="languages" />


        } @else if (type === LiveResultHeadingType.EVENT && event) {
        <app-language-output [hrLabel]="event.name" [enLabel]="event.nameEng" [itLabel]="event.nameIta"
          [siLabel]="event.nameSlo" [defaultLanguage]="event.defaultLanguage" [languages]="languages" />

        }
      </p>

      <div class="info__details flex-grow-1">
        <div class="bold-red item border-item {{cssClass ? cssClass : ''}}">{{ dateString }}</div>
        @if (type === LiveResultHeadingType.RACE) {
        <div class="bold-red item border-item {{cssClass ? cssClass : ''}}">{{ race?.raceStart | localizedDate:"HH:mm"
          }}
        </div>
        }
        @if (type === LiveResultHeadingType.RACE && race?.sport) {
        <div class="item border-item {{cssClass ? cssClass : ''}}">{{ t("app.common.sports." + race!.sport) }}</div>
        } @else if (type === LiveResultHeadingType.EVENT && event?.sportOne) {
        <div class="item border-item {{cssClass ? cssClass : ''}}">{{ t("app.common.sports." + event!.sportOne) }}
        </div>
        }

        @if (type === LiveResultHeadingType.EVENT && (event?.city || country)) {
        <div class="item {{cssClass ? cssClass : ''}}">
          {{ event?.city ?? "" }}{{ event?.city && country ? ", " : "" }}{{ country ?? "" }}
        </div>
        }

        @if (type === LiveResultHeadingType.RACE) {
        <div class="item border-item {{cssClass ? cssClass : ''}}">
          {{ t("event.item.participants") }}:
          <span class="fw-bold ps-1">{{ race?.competitorCount?.total ?? "-" }}</span>
        </div>
        @if (finished && finished > 0) {
        <div class="item {{cssClass ? cssClass : ''}}">
          {{ t("app.common.finished") }}:
          <span class="fw-bold ps-1">{{finished}}</span>
        </div>
        }
        }
      </div>
    </div>
    @if (!hideStatusBadge) {

    <div class="badge-holder">
      <div class="badge-holder__badge" [ngClass]="
          {'black': status === LiveItemStatus.FINISHED,
          'green': status === LiveItemStatus.IN_PROGRESS,
          'red': status === LiveItemStatus.TO_BE_STARTED,}">
        <span>{{ t("live.results.status." + status) }}</span>
      </div>
    </div>
    }
  </div>

</ng-container>
